import { jsx } from "react/jsx-runtime";
import { RadioGroupFieldWUT } from "../../../ui/radio-group-field/radio-group-field-wut.js";
import { FIELD_TYPES } from "../../../constants/field-types.js";
const RadioGroupWUT = (props) => {
  const { fieldType = FIELD_TYPES.RADIO_GROUP } = props;
  return /* @__PURE__ */ jsx(RadioGroupFieldWUT, { ...props, fieldType });
};
export {
  RadioGroupWUT
};
//# sourceMappingURL=radio-group-wut.js.map
